import "./MainContent.scss";

import TabSlider from "../tab-slider/TabSlider";

const MainContent = ({ setValue, value }) => {
  return (
    <div className="main-content">
      <TabSlider setValue={setValue} value={value} />
    </div>
  );
};

export default MainContent;
